import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row, Spinner, Alert } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Modal } from "react-responsive-modal";
import NavBar from "../Components/Navbar";
import YachtDetailsContact from "../Components/YachtDetailsContact";
import SimilarYacht from "../Components/SimilarYacht";
import { Helmet } from "react-helmet";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "react-responsive-modal/styles.css";
import { Img_URL4 } from "../Components/Ads_URL";

const YachtDetails = () => {
  const { id } = useParams();
  const contactRef = useRef(null);
  const [yacht, setYacht] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);

  const fetchYachtDetails = async () => {
    try {
      const response = await fetch(
        `https://americanyachtgroupinternational.com/api/documents?vessel_ids=${id}&gallery=true&media=true`
      );
      const data = await response.json();
      const yachtData = data?.yacht_data?.["V-Data"]?.[0];
      setYacht(yachtData);
    } catch (err) {
      console.error("Error fetching yacht details:", err);
      setError("Failed to load yacht details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchYachtDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5">
        <Alert variant="danger">{error}</Alert>
      </div>
    );
  }

  if (!yacht) {
    return (
      <div className="text-center py-5">
        <p>No yacht details found.</p>
      </div>
    );
  }

  return (
    <div>
      <Helmet>
        <title>
          {yacht.Manufacturer} {yacht.Model} | Yacht Details
        </title>
        <meta
          name="description"
          content={yacht.Description || "Explore yacht details."}
        />
      </Helmet>
      <NavBar />
      <div
        style={{
          // background: "radial-gradient(ellipse at 50% -50%,#f5f7fc 0, #d9e1f7)",
          height: "100px",
        }}
      ></div>
      <section class="c-banner container" data-aos="fade-up">
        <Row className="p-3 g-0">
          <Col xs={12} lg={6}>
            <h1 className="">
              {" "}
              {yacht.Manufacturer} {yacht.Model} {yacht.Year}
            </h1>
            <p className="mb-1">
              {yacht.City}, {yacht.State}, {yacht.Country}
            </p>
            <p className="">
              <span className="fw-bold" style={{ color: "#F38D2D" }}></span>{" "}
              {yacht.PriceHidden
                ? " Call For Price"
                : yacht.PriceUSD
                ? `$ ${yacht.PriceUSD.toLocaleString()}`
                : "Not Available"}
            </p>
          </Col>
          <Col xs={12} lg={6}>
            <div className="d-flex justify-content-end gap-3 my-3 flex-wrap">
              <a
                type="button"
                class="c-banner-btn"
                onClick={() => setFullScreenView(true)}
              >
                View Images <i class="fas fa-arrow-right"></i>
              </a>
              <a
                type="button"
                class="c-banner-btn"
                onClick={() =>
                  contactRef.current?.scrollIntoView({ behavior: "smooth" })
                }
              >
                Contact Broker <i class="fas fa-arrow-right"></i>
              </a>
            </div>{" "}
          </Col>
        </Row>
      </section>
      {/* Top Details Section */}
      <section
        style={{ backgroundColor: "#eeeeee" }}
        className="py-4 details-c-banner"
      >
        <Container fluid className="col-lg-11">
          <Row>
            {/* <Col xs={12} lg={6}>
              <h1
                className="mb-1 hero-h fw-bold"
                style={{ fontFamily: "Roboto", fontSize: "26px" }}
              >
                {yacht.Year} {yacht.Manufacturer} {yacht.Model}
              </h1>
              <p className="fs-5  mb-1 text-nowrap">
                <i
                  class="fa-solid fa-location-dot "
                  style={{ color: "#F38D2D" }}
                ></i>{" "}
                {yacht.City}, {yacht.Country}
              </p>
              <p className="fs-5  mb-1 text-nowrap">
                <span className=" fs-5 p-0 m-0" style={{ color: "#F38D2D" }}>
                  $
                </span>{" "}
                {yacht.PriceHidden
                  ? " Call For Price"
                  : yacht.PriceUSD
                  ? `${yacht.PriceUSD.toLocaleString()}`
                  : "Not Available"}
              </p>
            </Col>
            <Col xs={12} lg={6}>
              <div className="d-flex justify-content-end gap-3 my-3 flex-wrap">
                <button
                  type="button"
                  className="btn btn-sm fw-bold gradient-c1 me-2"
                  style={{ color: "#274c70" }}
                  onClick={() => setFullScreenView(true)}
                >
                  View Images
                </button>
                <button
                  type="button"
                  className="btn btn-sm fw-bold gradient-c1 me-2"
                  style={{ color: "#274c70" }}
                  onClick={() =>
                    contactRef.current?.scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Contact Broker
                </button>
              </div>
            </Col> */}

            {/* Swiper for Gallery */}
            <Col xs={12} lg={12}>
              <Swiper
                spaceBetween={10}
                slidesPerView={"auto"}
                navigation
                modules={[Navigation]}
                className="details-banner"
              >
                {(yacht?.gallery || []).map((img, i) => {
                  const imageUrl = img.HD || img.Large || img.Medium;
                  return (
                    <SwiperSlide className="detailed-swiper-slide" key={i}>
                      <img
                        src={imageUrl}
                        alt={`Yacht image ${i + 1}`}
                        loading="lazy"
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </Col>
          </Row>
        </Container>
      </section>
      {/* Full-Screen Modal */}
      <Modal
        open={fullScreenView}
        onClose={() => setFullScreenView(false)}
        center
        classNames={{ modal: "custom-modal" }}
      >
        <div className="details-popup">
          {(yacht?.gallery || []).length > 0 ? (
            <Swiper
              spaceBetween={10}
              slidesPerView={1}
              pagination={{ type: "fraction" }}
              navigation
              modules={[Navigation, Pagination]}
              className="details-popup"
            >
              {yacht.gallery.map((img, i) => {
                const imageUrl = img.HD || img.Large || img.Medium;
                return (
                  <SwiperSlide className="detailed-swiper-popup" key={i}>
                    <img
                      src={imageUrl}
                      alt={`Yacht image ${i + 1}`}
                      loading="lazy"
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <p className="text-center">No images available.</p>
          )}
        </div>
      </Modal>
      {/* Specifications */}
      <section className="my-4">
        <Container fluid className="col-lg-11">
          <Row>
            <Col xs={12} lg={6}>
              <h4 className="fw-bold text-primary-emphasis">
                Specification Overview
              </h4>
              <hr />
              <div className="row g-0 bg-transparent">
                {/* Left side (5 rows) */}
                <div className="col-sm-6">
                  <table className="table ">
                    <tbody>
                      <tr>
                        <th className="text-primary-emphasis">Year</th>
                        <td>{yacht.Year}</td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Make</th>
                        <td>{yacht.Manufacturer}</td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Model</th>
                        <td>{yacht.Model}</td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Type</th>
                        <td>{yacht.Type}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Right side (4 rows) */}
                <div className="col-md-6">
                  <table className="table ">
                    <tbody>
                      <tr>
                        <th className="text-primary-emphasis">Length</th>
                        <td>{yacht.DisplayLengthFeet} ft</td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Condition</th>
                        <td>{yacht.Condition || "Not Specified"}</td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Price</th>
                        <td>
                          {yacht.PriceHidden
                            ? "Call For Price"
                            : yacht.PriceUSD
                            ? `$${yacht.PriceUSD.toLocaleString()}`
                            : "Not Available"}
                        </td>
                      </tr>
                      <tr>
                        <th className="text-primary-emphasis">Category</th>
                        <td>{yacht.Category}</td>
                      </tr>
                      {/* <tr>
                        <th className="text-primary-emphasis">Location</th>
                        <td>
                          {yacht.City}, {yacht.State}, {yacht.Country}
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>

            <Col md={6} ref={contactRef}>
              <h4 className="fw-bold text-primary-emphasis">
                Inquire About {yacht.Manufacturer} {yacht.Model}
              </h4>
              <YachtDetailsContact yachtId={id} />
            </Col>
          </Row>
        </Container>
      </section>
      {/* Displaying Description */}
      <section className="my-4">
        <Container fluid className="col-lg-11">
          <h4 className="fw-bold text-primary-emphasis">General Description</h4>
          <hr />
          <Row className="border-bottom border-1">
            <Col xs={12} md={12} lg={8}>
              <div className="Featured-scroll-container">
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      yacht.Description || "<p>No description available.</p>",
                  }}
                />
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={4}
              style={{ backgroundColor: "#eeeeee" }}
              className="py-5"
            >
              <div className="text-center">
                {/* Mobile: Display Image 1 */}
                <Row className="d-md-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/ad2.gif"
                      alt="Mobile"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Tablet: Display Image 2 */}
                <Row className="d-none d-md-flex d-lg-none">
                  <Col>
                    <img
                      src="https://ayg.s3.us-east-2.amazonaws.com/ad2.gif"
                      alt="Tablet"
                      className="img-fluid"
                    />
                  </Col>
                </Row>

                {/* Desktop: Display Image 3 */}
                <Row className="d-none d-lg-flex">
                  <Col>
                    <img
                      src={Img_URL4}
                      alt="Desktop"
                      style={{ height: "600px" }}
                      className="img-fluid"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Disclaimer */}
      <section className="my-5">
        <Container fluid className="col-lg-11">
          <h4 className="fw-bold">Disclaimer</h4>
          <p>
            The Company offers the details of this vessel in good faith but
            cannot guarantee or warrant the accuracy of this information nor
            warrant the condition of the vessel. This vessel is offered subject
            to prior sale, price change, or withdrawal without notice.
          </p>
        </Container>
      </section>
      {/* Similar Yachts */}
      <section className="my-4">
        <Container fluid className="col-lg-11">
          <h4 className="fw-bold">Similar Yachts For Sale</h4>
          <SimilarYacht />
        </Container>
      </section>
    </div>
  );
};

export default YachtDetails;
